import { render } from "./speech.vue?vue&type=template&id=7829770d&ts=true"
import script from "./speech.vue?vue&type=script&lang=ts"
export * from "./speech.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__